export function toDateOnly(value) {
  if (!value) return "";
  return String(value).slice(0, 10);
}

export function localTodayIso(now = new Date()) {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// Los datos de identificación se reutilizan; las fechas de la visita anterior no.
export function admissionValuesForExistingInstrument(
  instrument,
  { receptionDate, calibrationPlace = "Laboratorio" } = {},
) {
  return {
    receptionDate: toDateOnly(receptionDate) || localTodayIso(),
    departureDate: "",
    calibrationPlace: calibrationPlace || instrument?.calibration_place || "Laboratorio",
  };
}

// Dentro de una OS, la fecha autoritativa es la creación de esa relación de
// servicio. instruments.reception_date queda únicamente como compatibilidad
// histórica para registros que todavía no tienen una OS identificable.
export function resolveAdmissionReceptionDate({
  serviceOrderCreatedAt,
  intakeCreatedAt,
  legacyReceptionDate,
} = {}) {
  return (
    toDateOnly(serviceOrderCreatedAt) ||
    toDateOnly(intakeCreatedAt) ||
    toDateOnly(legacyReceptionDate) ||
    null
  );
}

export function filterSegmentsForAdmission(segments, admissionStartedAt) {
  const startMs = Date.parse(admissionStartedAt || "");
  if (!Number.isFinite(startMs)) return Array.isArray(segments) ? segments : [];
  return (segments || []).filter((segment) => {
    const enteredMs = Date.parse(segment?.entered_at || "");
    return Number.isFinite(enteredMs) && enteredMs >= startMs;
  });
}

export function valueWithinAdmission(value, admissionStartedAt) {
  if (!value) return null;
  const startMs = Date.parse(admissionStartedAt || "");
  const valueMs = Date.parse(value);
  if (!Number.isFinite(startMs) || !Number.isFinite(valueMs)) return value;
  return valueMs >= startMs ? value : null;
}

const SERVICE_TO_INSTRUMENT_STATUS = {
  delivered_to_lab: "active",
  calibration_finished: "calibrated",
  certificates_finished_controlled: "reviewed",
  uploaded_for_remito: "ready_to_remit",
  remito_generated: "remitted",
  client_notified: "delivered",
};

const PREVIOUS_CYCLE_STATUSES = new Set([
  "reviewed",
  "ready_to_remit",
  "remitted",
  "delivered",
  "delivered_with_certificate",
  "delivered_without_certificate",
  "delivered_not_calibrated",
  "delivered_not_repaired",
  "delivered_repaired",
  "cancelled",
]);

export function isPreviousCycleStatus(status) {
  return PREVIOUS_CYCLE_STATUSES.has(status);
}

// Un estado terminal puede pertenecer a la visita anterior o a la actual.
// La fecha de revisión permite distinguir ambos casos sin reutilizar el
// historial viejo del instrumento al abrir una OS nueva.
export function hasCurrentAdmissionTransition({
  instrumentStatus,
  admissionStartedAt,
  reviewedAt,
} = {}) {
  if (!isPreviousCycleStatus(instrumentStatus)) return true;
  return Boolean(valueWithinAdmission(reviewedAt, admissionStartedAt));
}

export function resolveAdmissionStatus({
  instrumentStatus,
  serviceOrderStatus,
  hasCurrentCycleTransition,
} = {}) {
  if (hasCurrentCycleTransition || !SERVICE_TO_INSTRUMENT_STATUS[serviceOrderStatus]) {
    return instrumentStatus || "active";
  }
  return SERVICE_TO_INSTRUMENT_STATUS[serviceOrderStatus];
}

// La etiqueta puede redibujarse o reimprimirse, pero el valor codificado debe
// seguir siendo el identificador permanente del mismo instrumento.
export function permanentInstrumentQrValue(instrument) {
  if (!instrument) return null;
  const stored = String(instrument.qr_scan_value || instrument.qrScanValue || "").trim();
  if (stored) return stored;
  const labId = instrument.labId ?? instrument.lab_id;
  if (labId !== null && labId !== undefined && String(labId).trim()) return String(labId).trim();
  if (instrument.id) return String(instrument.id);
  return instrument.tag ? String(instrument.tag) : null;
}
